<template>
  <div class="hp-manager-dialog">
    <a-modal centered :title="title" :top="top" :width="width" @cancel="cancel" :footer="null" :visible.sync="visiable">
      <slot name="slot" v-if="visiable"></slot>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'hp-manager-modal',
  props: {
    value: Boolean,
    title: {
      type: String,
      default: '提示',
    },
    top: {
      type: String,
      default: '25vh',
    },
    width: {
      type: String,
      default: '850px',
    }
  },
  data () {
    return {
      visiable: false,
    }
  },
  watch: {
    value (val) {
      this.visiable = val;
    },
    visiable (val) {
      this.$emit('input', val);
    },
  },
  mounted () {
    this.visiable = this.value;
  },
  methods:{
      cancel(){
          this.visiable=false
      }
  }
  
}
</script>

<style lang="scss">
@import "../../assets/scss/output.scss";
@include b(dialog){
  @include e(footer){
    padding: 10px 15px;
    border-top: 1px solid #eee;
    text-align: right;
    margin-top: 30px;
    & > div{
      margin: 0;
    }
  }
  .el-dialog__header{
    padding: 0 15px;
    line-height: 50px;
    border-bottom: 1px solid #eee;
  }
  .el-dialog__title{
    font-size: 15px;
  }
  .el-dialog__headerbtn{
    top: 0;
    right: 15px;
    line-height: 50px;
  }
  .el-dialog__body{
    padding: 30px 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/modal.vue